import { useAppSelector } from '@redux/hooks';

import { selectCurrentTheme } from '@redux/selectors';
import { getTheme } from '@assets/styles/colors';

export const useThemeGetter = () => {
  const themeType = useAppSelector(selectCurrentTheme);
  const theme = getTheme(themeType);

  return {
    type: themeType,
    theme,
  };
};
